// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import './registerServiceWorker'
import mixin from './core/mixin'
import '@babel/polyfill'
import searchParams from 'url-search-params-polyfill'
// Plugins init
import overlay from './plugins/overlay'
// LANGUAGE
import './core/filters'
import i18n from './i18n'
// Layouts
import Default from './layouts/Default-Layout.vue'
import Login from './layouts/Login-Layout.vue'
import Campus from './layouts/Campus-Layout.vue'
// COMPONENTS
import LeftMenu from './components/domain/home/LeftMenu.vue'
import LeftMenuCampus from './components/domain/home/LeftMenuCampus.vue'
import Equipment from './components/ui/Equipment.vue'
import Shirt from './components/equipment/Shirt.vue'
import Shorts from './components/equipment/Shorts.vue'
import Socks from './components/equipment/Socks.vue'
import Uniform from './components/ui/Uniform.vue'
import PersonList from './components/ui/PersonList.vue'
import PersonEdit from './components/ui/PersonEdit.vue'
import ErrorPopup from './components/ui/ErrorPopup.vue'
import ConfirmPopup from './components/ui/ConfirmPopup.vue'
import SliderUniform from './components/ui/SliderUniform.vue'
import VueTelInput from 'vue-tel-input'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import VuejsClipper from 'vuejs-clipper'
Vue.use(searchParams)
Vue.use(overlay)

Vue.config.productionTip = false
Vue.use(i18n)
Vue.component('default-layout', Default)
Vue.component('login-layout', Login)
Vue.component('campus-layout', Campus)
Vue.component('left-menu', LeftMenu)
Vue.component('left-menu-campus', LeftMenuCampus)
Vue.component('equipment', Equipment)
Vue.component('shirt', Shirt)
Vue.component('shorts', Shorts)
Vue.component('socks', Socks)
Vue.component('uniform', Uniform)
Vue.component('person-list', PersonList)
Vue.component('person-edit', PersonEdit)
Vue.component('error-popup', ErrorPopup)
Vue.component('confirm-popup', ConfirmPopup)
Vue.component('slider-uniform', SliderUniform)
Vue.use(VueTelInput)

// Vue.use(Vuetify)
Vue.use(Vuetify, { theme: false })
Vue.use(VuejsClipper)

Vue.config.devtools = process.env.NODE_ENV === 'development'

function createApp () {
  const app = new Vue({
    store,
    i18n,
    router,
    components: { App },
    template: '<App/>',
    mixins: [mixin]
  })
  app.$mount('#app')
}

createApp()
